import { render, staticRenderFns } from "./ehc-message.vue?vue&type=template&id=266c9a80&scoped=true&class=ehc-message"
import script from "./ehc-message.vue?vue&type=script&lang=js"
export * from "./ehc-message.vue?vue&type=script&lang=js"
import style0 from "./ehc-message.vue?vue&type=style&index=0&id=266c9a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266c9a80",
  null
  
)

export default component.exports